export const environment = {
  production: true,
  buildId: '3854543741523631',
  configFile: 'config.json',
};
